import { getElementDiv, prepareRender, renderRoadmap, addDisplayTile } from "@/modules/commonRoadmapSmall";
import { IRoadmapSmallClass } from "@/types/RoadmapSmallTypes";

export default class M11 extends IRoadmapSmallClass {
	render() {
		prepareRender(this);

		//Obligatory counters
		let currentType = "";

		// Formats this.props.history to desired roadmap
		this.props.history.forEach((item, idx, ary) => {
			let ele = null;
			const angka = item.angka.split(",");
			let reds = 0;
			
			for (const a of angka) {
				switch (a) {
					case "1": ++reds; break;
					default: break;
				}
			}
			
			if (reds >= 2) {
				currentType = "red";
				ele = getElementDiv(this, ["circle", "red"], idx, ary);
			} else {
				currentType = "white";
				ele = getElementDiv(this, ["circle", "white"], idx, ary);
			}
			
			addDisplayTile(this.roadmapArray, ele, currentType, this);
		});
		
		return renderRoadmap(this);
	}
}
